export default class Attachment {
  constructor(opts = {}) {
    this.id = opts['@id'] || null;
  }
}

export const formatAttachment = (data) => new Attachment(data);
